import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AngularMaterialModule } from 'src/app/angular-material.module';
import { FieldsModule } from 'src/app/shared/components/fields/fields.module';
import { UserService } from './crud.service';

import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatDividerModule } from '@angular/material/divider';
import { MatSelectModule } from '@angular/material/select';
import { CurrencyMaskModule } from 'ng2-currency-mask';
import { TableResponsiveModule } from 'src/app/shared/components/table-responsive/table-responsive.module';
import { ApplicationPipesModule } from 'src/app/shared/pipes/application-pipes.module';
import { PermissionSelectorModule } from 'src/app/shared/components/permission-selector/permission-selector.module';
import { UserGroupService } from '../user-groups/crud-service';
import { UserPermissionService } from '../user-permissions/crud-service';
import { PermissionGroupService } from '../permission-groups/crud-service';
import { UserCESComponent } from './crud-ces/crud-ces.component';
import { UserCrudIndex } from './crud-index/crud-index';
import { UserIndexComponent } from './crud-index/crud-index.component';
import { UserIndexSelectComponent } from './crud-index/crud-index-select.component';
import { UserRoutingModule } from './crud-routing.module';
import { UserProfileCESComponent } from './user-profile-ces/crud-ces.component';
import { ResetPasswordDialogComponent } from './crud-index/reset-password-dialog/reset-password-dialog.component';

@NgModule({
  providers: [UserService, UserGroupService, UserPermissionService, PermissionGroupService],
  declarations: [
    UserCrudIndex,
    UserIndexComponent,
    UserIndexSelectComponent,
    UserCESComponent,
    UserProfileCESComponent,
    ResetPasswordDialogComponent,
  ],
  imports: [
    CommonModule,
    MatDividerModule,
    AngularMaterialModule,
    TableResponsiveModule,
    FlexLayoutModule,
    FormsModule,
    ReactiveFormsModule,
    FieldsModule,
    MatSelectModule,
    UserRoutingModule,
    MatAutocompleteModule,
    CurrencyMaskModule,
    ApplicationPipesModule,
    PermissionSelectorModule,
  ],
  exports: [],
})
export class UserModule {}
